// extracted by mini-css-extract-plugin
export default {"events":"events_events__k4m+u","events__body_head":"events_events__body_head__JNB9p","event_links":"events_event_links__LM-7t","active":"events_active__56X0P"};